import { getSiteName } from '../../../../utils/aem-utils';

import {
  renderHeading,
  renderMessengerPeople,
  renderMyTeam,
  renderMySport,
  renderMyLocalNews,
  renderPanel,
  renderWPN,
  renderNewsletter,
} from '.';

export const renderBlock = ({
  type,
  data,
  pageState,
  pageActions,
  WPNCtx,
  newslettersCtx,
  parselyCtx,
  widget,
  pageHandlers,
}) => {
  if (!data) {
    return null;
  }
  switch (type) {
    case widget.blockTypes.heading:
      return renderHeading(data);
    case widget.blockTypes.messengerPeople:
      return renderMessengerPeople({
        data,
        telegramWidgetId: widget.telegramWidgetId[getSiteName()],
        messengerWidgetId: widget.messengerWidgetId[getSiteName()],
      });
    case widget.blockTypes.notifications:
      return renderWPN({
        data,
        pageState,
        pageActions,
        WPNCtx,
        elementId: widget.elementIds.WPNId,
        type,
      });
    case widget.blockTypes.panel:
      return renderPanel(data);
    case widget.blockTypes.myTeam:
      return renderMyTeam({
        parselyCtx,
        data,
        type,
        pageState,
        pageActions,
        pageHandlers,
      });
    case widget.blockTypes.mySport:
      return renderMySport({
        parselyCtx,
        data,
        type,
        pageState,
        pageActions,
        pageHandlers,
      });
    case widget.blockTypes.myLocalNews:
      return renderMyLocalNews({
        parselyCtx,
        data,
        type,
        pageState,
        pageActions,
        pageHandlers,
      });
    case widget.blockTypes.newsletters:
      return renderNewsletter({
        newslettersCtx,
        data,
        type,
        pageState,
        pageActions,
        pageHandlers,
        elementId: widget.elementIds.newsletterId,
      });
    default:
      return null;
  }
};
